import { render, staticRenderFns } from "./AdminEtcMenu.vue?vue&type=template&id=d8aa9e1a&scoped=true&"
import script from "./AdminEtcMenu.vue?vue&type=script&lang=js&"
export * from "./AdminEtcMenu.vue?vue&type=script&lang=js&"
import style0 from "./AdminEtcMenu.vue?vue&type=style&index=0&id=d8aa9e1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8aa9e1a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
